import { render, staticRenderFns } from "./scope99.vue?vue&type=template&id=e12d954c&scoped=true"
import script from "./scope99.vue?vue&type=script&lang=js"
export * from "./scope99.vue?vue&type=script&lang=js"
import style0 from "./scope99.vue?vue&type=style&index=0&id=e12d954c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12d954c",
  null
  
)

export default component.exports